import ErrorSubscription from "../stores/ErrorSubscriptionStore";
import General from "../../src/stores/GeneralStore";
import convertBlobToJson from "../utils/bolbToJson";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NotifyError } from "./ShowError";
import { NotifySuccess } from "./ShowSuccess";
interface Obj {
  data?: string | {};
  errorId: string;
}

let values: any = {};

export const setValues = (labels: any) => {
  values = labels;
};

export const ErrorWrapper = (fn: any) => (allData: Obj) => {
  const notify = (message: any) => NotifyError(message);
  const { errorId, data } = allData;
  return Promise.resolve(fn(data)).catch((err) => {
    console.log("***Error Wrapper Caught Error:", err);
    if (err?.error && err.error[0].message !== "cm_mob_servrerr" && err.error[0].message !== "Token is not valid") {
      notify(
        err?.error && err.error[0].message?.toLowerCase()
          ? err.error[0].message
          : err.message
      );
    }
    if(err && err.message ){
      if(err?.message === "RecaptchaError"){
          notify(err.message);
      }
    
    }
   
    if (errorId) {
      ErrorSubscription.subscribe({
        message: `${
          err?.error && err.error[0].message
            ? values[err.error[0].message]?.label
            : "username or password is wrong"
        }`,
        id: errorId as string,
      });
    }
  });
};
